import Vue from "vue";
import axios from "axios";
import Highcharts from "highcharts";

import moment from "moment";

// Components
import "./components";

// Plugins
import "./plugins";
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import router from "@/router";
import store from "@/store";

Vue.use(Highcharts);

Vue.prototype.$Highcharts = Highcharts;
Vue.prototype.$axios = axios;
// Vue.prototype.$axios.defaults.baseURL = "https://app.nxtagro.io";
Vue.prototype.$axios.defaults.baseURL = "https://backend-op.nxtagro.io";

Vue.prototype.$moment = moment;

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (window) {
  window._chatlio = window._chatlio || [];
  !(function () {
    var t = document.getElementById("chatlio-widget-embed");
    if (t && window.ChatlioReact && _chatlio.init)
      return void _chatlio.init(t, ChatlioReact);
    for (
      var e = function (t) {
        return function () {
          _chatlio.push([t].concat(arguments));
        };
      },
      i = [
        "configure",
        "identify",
        "track",
        "show",
        "hide",
        "isShown",
        "isOnline",
        "page",
        "open",
        "showOrHide",
      ],
      a = 0;
      a < i.length;
      a++
    )
      _chatlio[i[a]] || (_chatlio[i[a]] = e(i[a]));
    var n = document.createElement("script"),
      c = document.getElementsByTagName("script")[0];
    (n.id = "chatlio-widget-embed"),
      (n.src = "https://w.chatlio.com/w.chatlio-widget.js"),
      (n.async = !0),
      n.setAttribute("data-embed-version", "2.3");
    n.setAttribute("data-widget-id", "e563b7d8-781c-4f8e-61fa-f0f24c80a801");
    c.parentNode.insertBefore(n, c);
  })();
}
